import { Layout } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Outlet } from "react-router";
import { Kiosk } from "../../API";
import { useAppSelector } from "../../app/hooks";
import { selectPlayer } from "../../features/player/playerSlice";
import {
  selectTheme,
  setMode,
  setShowPinForm,
  showLoginPopup,
  ThemeColor,
  ThemeMode,
} from "../../features/theme/themeSlice";
import HeaderLinks from "../WelcomeLayout/components/HeaderLinks";
import LoginFormPopup from "../WelcomeLayout/components/LoginFormPopup";
import Logo from "../WelcomeLayout/components/Logo";
import LoggedControls from "../WelcomeLayout2/components/LoggedControls";
import HeaderIcons from "./components/HeaderIcons";
import { useNavigate } from "react-router-dom";

const { Content, Footer, Sider, Header } = Layout;

const KioskAdminLayout = () => {
  const [kioskData, setKioskData] = useState<Kiosk | null>(null);

  const theme = useAppSelector(selectTheme);
  const player = useAppSelector(selectPlayer);
  const dispatch = useDispatch();

  let t = null;
  useEffect(() => {
    dispatch(setMode(ThemeMode.KIOSKADMIN));
    localStorage.setItem("kiosk", "false");
  }, []);
  return (
    <Layout
      className={`kiosk fullwidth ${
        theme.theme === ThemeColor.dark ? "d-dark" : "d-light"
      }`}
    >
      <Header className="header-kiosk">
        <div className="d-logo hcol">
          <Logo />
        </div>

        <div className="d-flex f-right f-row header-right-icons">
     
          <HeaderIcons />
        </div>
      </Header>
      <Content style={{marginTop:100}}>
        <Outlet />
      </Content>
     
    </Layout>
  );
};

export default KioskAdminLayout;
